import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_VERSION } from '../config/buildInfo';
import { useBrand } from '../context/BrandContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { brand, assets } = useBrand();

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <div className="landing-page">
      <div className="landing-hero" style={{ backgroundImage: `url('${assets.heroUrl}')` }}>
        <div className="landing-topbar">
          <img src={assets.logoUrl} alt={brand.productName} />
          <span>v{APP_VERSION}</span>
        </div>

        <div className="landing-copy">
          <span className="landing-kicker">{brand.tagline}</span>
          <h1>{brand.productName}</h1>
          <p>
            Report, review, investigate, and close incidents with a controlled workflow
            built for quality teams, staff, and department leaders.
          </p>
          <div className="landing-actions">
            <button type="button" onClick={handleGetStarted}>
              <i className="bi bi-box-arrow-in-right" aria-hidden="true"></i>
              Sign In
            </button>
          </div>
        </div>

        <div className="landing-stats" aria-label="Workflow highlights">
          <div>
            <strong>Role based</strong>
            <span>Access and routing</span>
          </div>
          <div>
            <strong>Registry</strong>
            <span>{brand.taglineShort || 'OVR reporting'}</span>
          </div>
          <div>
            <strong>Traceable</strong>
            <span>Status history</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
